// extracted by mini-css-extract-plugin
export var richtext = "_richtext-module--richtext--352b5";